import React from "react";
import Services from "./Services";
import TechStackCitations from "./TechStackCitations";
import useSEO from "./useSEO";

const ServicePage = () => {
  useSEO({
    title: "Custom Shopify Store Development, Mobile Apps & SaaS MVPs | Core Spectators",
    description: "Explore our full-stack software development services: bespoke Shopify 2.0 storefronts, cross-platform Flutter mobile apps, multi-tenant SaaS MVPs, and intelligent AI workflow automations.",
    keywords: "custom shopify store development, shopify theme development liquid, headless shopify hydrogen, recharge subscription portal, flutter mobile app development, react native cross platform apps, saas mvp development agency, multi tenant saas architecture react node, stripe subscription billing integration, ai workflow automation consulting, enterprise n8n workflows, conversational ai voice agent twilio, software engineering agency",
    canonical: "https://corespectators.com/Services",
    schema: {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "E-Commerce, Mobile App & SaaS Development",
      "provider": {
        "@type": "Organization",
        "name": "Core Spectators",
        "url": "https://corespectators.com"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Core Spectators Engineering Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Custom Shopify 2.0 & Headless E-Commerce Development",
              "description": "High-converting bespoke Shopify stores, Liquid sections, Recharge subscriptions, and Hydrogen headless builds."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Cross-Platform Mobile Apps (Flutter & React Native)",
              "description": "Production-ready iOS and Android mobile apps with silky 60fps native UI, offline storage, and in-app payments."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Custom SaaS Platforms & MVP Engineering",
              "description": "Zero-to-one SaaS platform architecture, multi-tenant databases, Stripe billing, and user team workspaces."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "High-Performance Backend APIs & Cloud DevOps",
              "description": "High-throughput REST & GraphQL microservices, Redis caching, Docker containerization, and AWS/GCP cloud deployments."
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "Autonomous AI Workflows & Conversational Voice Telephony",
              "description": "Multi-agent autonomous business workflows using n8n/LangChain, 24/7 AI voice calling agents, and custom RAG chatbots."
            }
          }
        ]
      }
    }
  });

  return (
    <>
      <Services />
      <TechStackCitations />
    </>
  );
};

export default ServicePage;